import { TFunction } from '@gem/modules/i18n';

import {
  TSystemMessageTextHandler,
  ISystemMessageText,
  ISystemMessageTextPresenter,
} from '../useSystemMessageText.types';

export const chatMessagePinnedHandler: TSystemMessageTextHandler = (
  presenter: ISystemMessageTextPresenter,
  t: TFunction
): ISystemMessageText => {
  if (presenter.isPublicGroup || presenter.isChannel) {
    return {
      html: t('pinned_message_system_notification_without_name'),
    };
  }
  return {
    html: t('pinned_message_system_notification', {
      0: `<span class="system-message-title">${presenter.initiatorDisplayName}</span>`,
      interpolation: { escapeValue: false },
    }),
    sourceText: t('pinned_message_system_notification'),
    params: {
      '{0}': { text: presenter.initiatorDisplayName, userId: presenter.initiator?.id },
    },
  };
};
